import React from 'react';
import {NotredameSaudeAppIconProps} from './types';

export const NotredameSaudeAppIcon = ({size}: NotredameSaudeAppIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		style={{minWidth: size || 34}}
		viewBox="0 0 64 64"
		fill="none">
		<rect width="64" height="64" fill="#001453" />
		<path
			d="M21.4208 15.0252C18.7403 16.6993 16.4855 18.9905 14.8543 21.7C14.8126 21.7693 14.8646 21.8583 14.9454 21.8564C18.1069 21.7861 21.1623 21.4195 23.7204 20.7336C23.2418 18.9416 22.5012 17.0157 21.5746 15.0704C21.5471 15.0127 21.4749 14.9914 21.4208 15.0252Z"
			fill="white"
		/>
		<path
			d="M28.4915 16.907C29.8663 15.5493 31.2267 13.9019 32.5139 12.0803C32.5354 12.0497 32.5142 12.007 32.4769 12.0061C32.3184 12.0022 32.1594 12 32 12C29.6634 12 27.4209 12.4018 25.3364 13.1382C25.2986 13.1516 25.2848 13.1986 25.309 13.2305C26.3421 14.5974 27.4122 15.8419 28.4915 16.907Z"
			fill="white"
		/>
		<path
			d="M48.7662 21.0937C46.0859 16.9818 41.9343 13.9176 37.0581 12.6467C36.8588 12.5948 36.6488 12.6825 36.5504 12.8634C35.0942 15.5379 33.9375 18.2567 33.2778 20.723C37.5729 21.8773 43.2724 22.1349 48.5229 21.5981C48.7671 21.5731 48.9002 21.2993 48.7662 21.0937Z"
			fill="white"
		/>
		<path
			d="M28.4904 28.378C25.0529 31.7724 21.7638 38.1088 21.0425 42.6162C20.7178 44.6502 20.6573 46.5176 20.8259 48.1843C20.8542 48.4641 21.0104 48.7143 21.2473 48.8656C24.3525 50.8496 28.0418 52 32 52C32.9855 52 33.9539 51.9276 34.9011 51.7897C35.1803 51.7489 35.4162 51.5571 35.5064 51.2896C36.2857 48.9771 36.4835 46.0305 35.9384 42.6162C35.217 38.1088 31.9279 31.7689 28.4904 28.378Z"
			fill="white"
		/>
		<path
			d="M13.3652 25.2575C13.2386 25.2711 13.1307 25.3568 13.0893 25.4772C12.384 27.5218 12 29.7159 12 31.9999C12 34.8322 12.5891 37.5266 13.6508 39.9681C13.7189 40.1248 13.9159 40.1757 14.0539 40.075C14.3719 39.8427 14.6908 39.5987 15.0101 39.3421C18.5857 36.4719 22.4752 30.478 23.7177 25.8233C20.8019 25.0401 16.9178 24.8754 13.3652 25.2575Z"
			fill="white"
		/>
		<path
			d="M51.5745 27.8801C51.5142 27.5922 51.3215 27.3494 51.0544 27.226C50.5368 26.9869 49.9955 26.7586 49.43 26.5429C45.1366 24.9022 37.9613 24.5597 33.2814 25.8167C34.5239 30.4679 38.4066 36.4654 41.9752 39.3425C44.1235 41.0707 46.2484 42.2488 48.2376 42.9055C48.497 42.9912 48.7808 42.8866 48.9266 42.6555C50.8729 39.5706 52 35.9172 52 32C52 30.5876 51.8531 29.2097 51.5745 27.8801Z"
			fill="white"
		/>
	</svg>
);
